// Sound on and off, remembered on the device. 44 px target. Turning sound on unlocks audio (it is a tap) and plays a
// soft pop so people know it worked. variant="chip" shows the words too (the lobby's "Sound on" chip).
import { Volume2, VolumeX } from 'lucide-react';
import { sfx, useMuted } from '@/audio/sfx';

export function MuteToggle({ className = '', variant = 'icon' }: { className?: string; variant?: 'icon' | 'chip' }) {
  const [muted, setMuted] = useMuted();
  const toggle = () => {
    const next = !muted;
    setMuted(next);
    if (!next) { sfx.unlock(); sfx.play('pop'); }
  };
  const Icon = muted ? VolumeX : Volume2;
  const label = muted ? 'Turn sound on' : 'Turn sound off';
  if (variant === 'chip') {
    return (
      <button type="button" onClick={toggle} aria-pressed={!muted} aria-label={label}
        className={`inline-flex min-h-11 items-center gap-2 rounded-badge border-2 px-4 text-sm font-semibold transition-colors ${muted ? 'border-line bg-surface text-ink-2' : 'border-brand bg-brand-tint text-brand-deep'} ${className}`}>
        <Icon aria-hidden="true" className="size-4" strokeWidth={2.4} />
        <span aria-hidden="true">{muted ? 'Sound off' : 'Sound on'}</span>
      </button>
    );
  }
  return (
    <button type="button" onClick={toggle} aria-pressed={!muted} aria-label={label}
      className={`inline-flex size-11 shrink-0 items-center justify-center rounded-full border-2 border-line bg-surface text-ink-2 shadow-[0_2px_0_var(--line-strong)] transition-[transform,color] active:translate-y-[1px] ${muted ? '' : 'text-brand-strong'} ${className}`}>
      <Icon aria-hidden="true" className="size-5" strokeWidth={2.3} />
    </button>
  );
}
